import React, { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/react-hooks';

import EndSurveyImages from '../EndSurveyImages/EndSurveyImages';
import TranslationInputField from '../TranslationInputField/TranslationInputField';

import styles from './CampaignFailedPage.module.css';

import GooglePlayStore from '../../../../assets/img/play-store.png';
import AppleStore from '../../../../assets/img/app-store.png';

import {
  CUSTOM_THEME_COLOR_NAMES,
  CUSTOM_THEME_IMAGE_NAMES
} from '../../../../../clients/surveys/helpers/constants';

import { GET_CAMPAIGN } from '../../../../graphql/Campaigns';

export default ({
  campaign,
  match,
  location: { search },
  setCampaign,
  setHideBufflLogo,
  customTranslationsLoaded,
  setCustomTranslations,
  translations,
  updateTranslationsLanguage,
  setCustomThemeBaseColor,
  setCustomThemeImage,
  selectedLanguage,
  savingTranslationError,
  setSavingTranslationError,
  clientId
}) => {
  const [resizeTranslationField, setResizeTranslationField] = useState(false);

  const [getCampaign, { loading: loadingResult }] = useLazyQuery(GET_CAMPAIGN, {
    fetchPolicy: 'network-only',
    onCompleted: response => {
      if (response && response.campaign) {
        setCampaign(response.campaign);
      }
    }
  });

  useEffect(() => {
    if (!campaign) {
      getCampaign({
        variables: {
          id: match.params.campaignId,
          referrer: match.params.userId
        }
      });
    }
  }, []);

  useEffect(
    () => {
      if (campaign && campaign.hideLogoInWebSurvey && campaign.customBranding)
        setHideBufflLogo(true);
      if (
        campaign &&
        !(campaign.customCopies && campaign.customCopies.length)
      ) {
        updateTranslationsLanguage(
          campaign.language ||
            localStorage.getItem('campaignLanguage') ||
            selectedLanguage
        );
      }
      if (
        !customTranslationsLoaded &&
        campaign &&
        campaign.customCopies &&
        campaign.customCopies.length
      ) {
        setCustomTranslations(
          campaign.language ||
            localStorage.getItem('campaignLanguage') ||
            selectedLanguage,
          campaign.customCopies
        );
        setResizeTranslationField(customCopyFields.notEligible.name);
      }
      if (customThemeBaseColor) setCustomThemeBaseColor(customThemeBaseColor);
      if (customThemeImage) {
        setCustomThemeImage({
          NAME: customThemeLogoName,
          IMAGE: customThemeLogoImage
        });
      }
    },
    [campaign]
  );

  if (loadingResult && !campaign) {
    return null;
  }

  document.documentElement.scrollTop = 0;

  const customCopyFields = {
    notEligible: {
      name: 'notEligible',
      fields: {
        UNFORTUNATELY_ON_FAILED_PAGE: 'UNFORTUNATELY_ON_FAILED_PAGE',
        YOU_ARE_NOT_ELIGIBLE: 'YOU_ARE_NOT_ELIGIBLE',
        UNFORTUNATELY_YOU_ARE_NOT_ELIGIBLE:
          'UNFORTUNATELY_YOU_ARE_NOT_ELIGIBLE',
        DO_NOT_WORRY_DOZENS_OF_RESEARCHES_FAILED:
          'DO_NOT_WORRY_DOZENS_OF_RESEARCHES_FAILED'
      }
    }
  };

  const isTesting = () => search === '?test=true';

  const customThemeBaseColor =
    campaign &&
    campaign.customBranding &&
    campaign.customThemeColors &&
    campaign.customThemeColors.length &&
    campaign.customThemeColors.find(
      cT => cT.name === CUSTOM_THEME_COLOR_NAMES.BASE
    ).colorCode;

  const customThemeImage =
    campaign &&
    campaign.customBranding &&
    campaign.customThemeImages &&
    campaign.customThemeImages.length;

  const customThemeLogoName =
    campaign &&
    campaign.customBranding &&
    campaign.customThemeImages &&
    campaign.customThemeImages.length &&
    campaign.customThemeImages.find(
      cT => cT.name === CUSTOM_THEME_IMAGE_NAMES.LOGO
    ).name;

  const customThemeLogoImage =
    campaign &&
    campaign.customBranding &&
    campaign.customThemeImages &&
    campaign.customThemeImages.length &&
    campaign.customThemeImages.find(
      cT => cT.name === CUSTOM_THEME_IMAGE_NAMES.LOGO
    ).imageFilename;

  const allowedToEditTranslations =
    campaign &&
    isTesting() &&
    clientId &&
    ((campaign.client && campaign.client === clientId) ||
      (campaign.collaborators &&
        campaign.collaborators.length &&
        campaign.collaborators.find(c => c.id === clientId)));

  const translationInputFieldProps = campaign
    ? {
        surveyId: campaign.id,
        clientId,
        language:
          campaign.language ||
          selectedLanguage ||
          localStorage.getItem('campaignLanguage'),
        disabled: !allowedToEditTranslations || savingTranslationError,
        testing: isTesting(),
        setSavingTranslationError,
        resizeTranslationField,
        setResizeTranslationField
      }
    : {};

  return (
    <div className={styles.sucessfullyCompletedContainer}>
      <EndSurveyImages
        page="NOT_ELIGIBLE"
        hideIllustrationsInWebSurvey={
          campaign &&
          campaign.hideIllustrationsInWebSurvey &&
          campaign.customBranding
        }
        hideDownloadBufflInWebSurvey={
          campaign && campaign.hideDownloadBufflInWebSurvey
        }
        customThemeBaseColor={customThemeBaseColor}
      />
      <div
        className={
          campaign && campaign.hideDownloadBufflInWebSurvey
            ? `${styles.mainContainer} ${styles.mainContainerDownloadHidden}`
            : styles.mainContainer
        }
      >
        <div className={styles.contentContainer}>
          <TranslationInputField
            name={customCopyFields.notEligible.name}
            translationKey={
              campaign && campaign.hideDownloadBufflInWebSurvey
                ? customCopyFields.notEligible.fields
                    .UNFORTUNATELY_ON_FAILED_PAGE
                : customCopyFields.notEligible.fields
                    .UNFORTUNATELY_YOU_ARE_NOT_ELIGIBLE
            }
            value={
              campaign && campaign.hideDownloadBufflInWebSurvey
                ? translations[
                    customCopyFields.notEligible.fields
                      .UNFORTUNATELY_ON_FAILED_PAGE
                  ]
                : translations[
                    customCopyFields.notEligible.fields
                      .UNFORTUNATELY_YOU_ARE_NOT_ELIGIBLE
                  ]
            }
            customClasses={`${styles.title} ${
              campaign && campaign.hideDownloadBufflInWebSurvey
                ? styles.hideDownloadTitle
                : ''
            } campaign-user-details-waiting-to-confirm-title`}
            {...translationInputFieldProps}
          />

          <TranslationInputField
            name={customCopyFields.notEligible.name}
            translationKey={
              campaign && campaign.hideDownloadBufflInWebSurvey
                ? customCopyFields.notEligible.fields.YOU_ARE_NOT_ELIGIBLE
                : customCopyFields.notEligible.fields
                    .DO_NOT_WORRY_DOZENS_OF_RESEARCHES_FAILED
            }
            value={
              campaign && campaign.hideDownloadBufflInWebSurvey
                ? translations[
                    customCopyFields.notEligible.fields.YOU_ARE_NOT_ELIGIBLE
                  ]
                : translations[
                    customCopyFields.notEligible.fields
                      .DO_NOT_WORRY_DOZENS_OF_RESEARCHES_FAILED
                  ]
            }
            customClasses={`${styles.description}`}
            {...translationInputFieldProps}
          />
          {!(campaign && campaign.hideDownloadBufflInWebSurvey) && (
            <div className={styles.appStoreButtons}>
              <a
                target="_blank"
                href="https://play.google.com/store/apps/details?id=org.nativescript.buffl"
                rel="noopener noreferrer"
              >
                <img src={GooglePlayStore} alt="Google Play Store Button" />
              </a>
              <a
                target="_blank"
                href="https://itunes.apple.com/be/app/buffl/id1356715033?l=nl&mt=8"
                rel="noopener noreferrer"
              >
                <img src={AppleStore} alt="App Store Button" />
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
